// Import model
import { UpdateProjectSelectionRequest } from '../models/UpdateProjectSelectionRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { UpdateSelectionBinRequest } from '../models/UpdateSelectionBinRequest';

// Import dependency serializers (for complex types)
import { UpdateSelectionBinRequestSerializer } from './UpdateSelectionBinRequestSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for UpdateProjectSelectionRequest - handles JSON serialization and deserialization with type validation
 */
export class UpdateProjectSelectionRequestSerializer {
  /**
   * Deserializes a JSON string into a UpdateProjectSelectionRequest instance
   */
  static deserialize(json: string): UpdateProjectSelectionRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a UpdateProjectSelectionRequest instance
   */
  static fromObject(obj: any): UpdateProjectSelectionRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to UpdateProjectSelectionRequest');
    }


    const instance: UpdateProjectSelectionRequest = {
      itemIds: obj['itemIds'] ? (obj['itemIds'] as any[]).map((item: any) =>
        item as string
      ) : [] as any,
      selectionBins: obj['selectionBins'] ? (obj['selectionBins'] as any[]).map((item: any) =>
        UpdateSelectionBinRequestSerializer.fromObject(item)
      ) : [] as any,
      name: obj['name'] as string | undefined,
      description: obj['description'] as string | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of UpdateProjectSelectionRequest instances
   */
  static deserializeArray(json: string): UpdateProjectSelectionRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a UpdateProjectSelectionRequest instance to a JSON string
   */
  static serialize(instance: UpdateProjectSelectionRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a UpdateProjectSelectionRequest instance to a plain object
   */
  static toObject(instance: UpdateProjectSelectionRequest): any {
    return {
      'itemIds': instance.itemIds?.map((item: any) =>
        item
      ),
      'selectionBins': instance.selectionBins?.map((item: any) =>
        UpdateSelectionBinRequestSerializer.toObject(item)
      ),
      'name': instance.name,
      'description': instance.description,
    };
  }

  /**
   * Serializes an array of UpdateProjectSelectionRequest instances to a JSON string
   */
  static serializeArray(instances: UpdateProjectSelectionRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
